// modules
import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// constants
import { Routes, USER_INFO_COOKIE } from "constants/global";

// redux
import { isUserAuthDataAavailableSelector, resetAppData } from "redux/userList/userSlice";
import { useAppDispatch, useAppSelector } from "app/hooks/hooks";

// utils
import { getCookie, invalidateCookie, setCookie } from "utils/token";
import { refreshUserSession } from "utils/TokenUtils/refreshUserSession";
import { resetClaimState } from "redux/retroClaim/retroClaimSlice";
import { resetReimbState } from "redux/reimbursement/reimbursementSlice";
import { resetRoleManagementState } from "redux/roleManagement/roleManagementSlice";

export function useAuthCheck() {
	const cookie = getCookie("USER_INFO_COOKIE");
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const isUserAuthDataAavailable = useAppSelector(isUserAuthDataAavailableSelector);

	const clearAndNavigateToLogin = useCallback(() => {
		dispatch(resetAppData());
		dispatch(resetClaimState());
		dispatch(resetReimbState());
		dispatch(resetRoleManagementState());
		invalidateCookie();
		navigate(Routes?.LOGIN, { state: { path: location?.pathname } });
	}, [dispatch, resetAppData, navigate]);

	useEffect(() => {
		// If user not loggedIn and trying to access the any route
		// navigate him to login page with pathname information.
		// Try to get the token before navigation, if user received correct token proceed
		// otherwise navigate to login.

		if (!cookie && isUserAuthDataAavailable) {
			let newSession;
			try {
				const refreshToken = async () => {
					newSession = await refreshUserSession();

					if (!newSession?.idToken || !newSession?.idToken?.exp || !newSession?.idToken?.iat) {
						clearAndNavigateToLogin();
						return;
					}

					const cookie_ttl = parseInt(newSession?.idToken?.exp) - parseInt(newSession?.idToken?.iat);
					setCookie(USER_INFO_COOKIE, JSON.stringify(newSession?.idToken), cookie_ttl);
				};

				refreshToken();
			} catch (error) {
				clearAndNavigateToLogin();
			}
		}
	}, [location]);
}
